import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    image: 'https://cdn.magicpatterns.com/uploads/bgX9bG8RQp6MamQx6jMAND/daniel-romero-aiUAxBNe3Xk-unsplash.jpg',
    title: 'Free Cellular Phones',
    desc: 'Stay connected with a free smartphone through Lifeline. No hidden fees, no surprises.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/7EXdujL8UJY4PK1w2cBReD/kelly-sikkema-iVNkiqd_ZLg-unsplash.jpg',
    title: 'Free Tablets & Service',
    desc: 'Qualifying households receive a free tablet and service. Just a one-time $23 activation fee.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/oFDWFN1qPNPJPLBMtqfQV1/scott-rodgerson-PSpf_XgOM5w-unsplash.jpg',
    title: 'Free Home Internet',
    desc: 'Reliable home internet at no cost for eligible families. Stay online for school, work, and beyond.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/gyKkQeUVRhHPMw8UDdwjXe/online-marketing-hIgeoQjS_iE-unsplash.jpg',
    title: 'Free Healthcare Insurance',
    desc: 'Access free healthcare insurance options for you and your dependents.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/rUcQ7QNsWT66oaVfVNMfbR/james-yarema-G3q7mxXkP-M-unsplash.jpg',
    title: 'Discounted Cell Phone Service',
    desc: 'Lower your monthly bill with our discounted plans designed for working families.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="bg-brand-black py-16 md:py-24 relative" data-id="element-165">
      <div className="absolute inset-0 film-grain z-0" data-id="element-166" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-167">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-168">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-brand-lime font-mono font-bold tracking-widest uppercase text-sm mb-4" data-id="element-169">
            What We Offer
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-brand-soft text-[44px] md:text-[60px] leading-[0.95] font-display mb-6 uppercase" data-id="element-170">
            Built to Empower the Underserved
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-soft/80 text-base md:text-lg font-sans" data-id="element-171">
            Five core services designed to keep families connected, healthy, and
            supported. If you qualify, you pay nothing.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="flex flex-wrap justify-center gap-5 md:gap-6" data-id="element-172">
          {services.map((service, idx) => <motion.div key={idx} variants={itemVariants} className="w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] bg-brand-offblack border-2 border-brand-concrete hover:border-brand-lime hover:-translate-y-1 transition-all duration-300 flex flex-col group" data-id="element-173">
              <div className="relative h-48 overflow-hidden" data-id="element-174">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-175" />
                <div data-service={service.title} className="absolute inset-0 bg-brand-black/40 group-hover:bg-brand-black/10 transition-colors duration-300" data-id="element-176" />
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-177">
                <div className="text-brand-lime font-mono text-sm mb-3" data-id="element-178">
                  {String(idx + 1).padStart(2, '0')} /{' '}
                  {service.title.toUpperCase()}
                </div>
                <h3 className="text-2xl font-display uppercase tracking-wide text-brand-soft mb-3" data-id="element-179">
                  {service.title}
                </h3>
                <p className="text-brand-soft/70 mb-8 flex-grow font-sans" data-id="element-180">
                  {service.desc}
                </p>
                <a href="#qualify" className="inline-flex items-center gap-2 text-brand-lime font-mono font-bold text-sm uppercase tracking-widest hover:text-white transition-colors mt-auto min-h-[44px]" data-id="element-181">
                  Book Now <ArrowRight size={18} data-id="element-182" />
                </a>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}